<div id="chartProfitabily" [ngStyle]="{ width: '100%', height: '100%' }"></div>
<div class="flex flex-row justify-between text-xs chart-label md:text-sm">
  <span bp-text-values-card>Hoy</span>
  <span bp-text-values-card class="pr-[40px]"
    >En {{ simulation ? (simulation.values.length / 12 | number: '1.0-0') : '0' }}
    {{ simulation ? (simulation.values.length / 12 > 1 ? 'años' : 'año') : '' }}</span
  >
</div>
<bp-tooltip-chart #tool class="hidden" [tooltip]="tooltip"></bp-tooltip-chart>
